/**
 * マーク・アイコンマスタ画面のアイコン情報一覧クラス
 *
 * @export CwsIconData
 * @class CwsIconData
 */
export class CwsIconData {
    constructor(
        public iconCode: string,
        public iconCodeBranch: string,
        public iconGroupCode: string,
        public iconName: string,
        public iconImageUrl: string,
        public iconAlternativeText: string,
        public delivCatalogIdStart: string,
        public delivCatalogIdEnd: string,
        public delivEndDate: string,
        public iconDiv: string,
        public arrangeDiv: string,
        public iconExplain: string,
        public outputDiv: string,
        public updateDate: string
    ) { }
}
